import { APIConstant } from '../../services/api-constant';
import query from '../../services/api/api-service';
import { API_METHOD } from 'services/api/api-service-constants';

const getInterviewQuestion = async () => {
  try {
    const response = await query(APIConstant.getInterviewQuestion, true, {}, API_METHOD.GET, true);
    return response;
  } catch (error) {
    return error;
  }
};

export {
  getInterviewQuestion
};
